import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import settings from '../../../api/settings/hooks'
import { Property } from '../../../api/properties/types'
import { APPLICATION_SETTINGS, PROPERTY_STATUS } from '../../../common/constants'
import { propertyTransactionsInputs } from '../../../common/forms/generalRealEstate/inputs'
import { propertyTransactionsValidation } from '../../../common/forms/generalRealEstate/validations'
import { selectPropertyStatusFilter } from '../../../store/formFilters'

export const usePropertyTransactionsFormConfig = (data: Property | null) => {
    const { data: applicationMarket } = settings.GetApplicationSettings.useQuery({
        select: (data) => data.applicationMarket,
    })
    const storePropertyStatusId = useSelector(selectPropertyStatusFilter)

    const propertyStatusId = storePropertyStatusId || data?.propertyStatus?.id
    const propertyServiceId = data?.propertyService?.id

    const appSettings = useMemo(
        () => ({
            currency: APPLICATION_SETTINGS.CURRENCY,
            lang: APPLICATION_SETTINGS.DEFAULT_LANGUAGE,
            areaUnit: APPLICATION_SETTINGS.AREA_UNIT,
            applicationMarket,
        }),
        [applicationMarket]
    )

    const requiredFields = useMemo(() => {
        const soldRentedStatuses = [PROPERTY_STATUS.SOLD, PROPERTY_STATUS.SOLD_ARCHIVED, PROPERTY_STATUS.RENTED, PROPERTY_STATUS.RENTED_ARCHIVED]

        return {
            soldRented: soldRentedStatuses.includes(+propertyStatusId),
            reserved: PROPERTY_STATUS.RESERVED === +propertyStatusId,
        }
    }, [propertyStatusId])

    const transactionsInputs = useMemo(() => {
        return propertyTransactionsInputs(appSettings, propertyServiceId, propertyStatusId, requiredFields)
    }, [appSettings, propertyServiceId, propertyStatusId, requiredFields])

    const transactionsValidationConfig = useMemo(() => {
        return propertyTransactionsValidation(appSettings, data, propertyServiceId, requiredFields)
    }, [appSettings, data, propertyServiceId, requiredFields])

    return {
        transactionsInputs,
        transactionsValidationConfig,
    }
}
